import Layout from '../views/layout/Layout'

export default {
  path: '/mental',
  component: Layout,
  redirect: '/mental/word',
  name: 'mental',
  meta: {title: '心理健康', icon: 'data-center'},
  children: [
    {
      path: 'word',
      name: 'word',
      component: () => import('@/views/mental/word.vue'),
      meta: {title: '检测数据 ', icon: 'word'}
    },
    {
      path: 'report',
      name: 'report',
      component: () => import('@/views/mental/report/index.vue'),
      meta: {title: '查看报告与问卷详情', icon: 'store-list'},
      hidden: true
    },
  ]
}


// WEBPACK FOOTER //
// ./src/router/mental.js